import { forceCollide } from 'd3-force';

import { D3LayoutNode } from 'src/containers/ProjectDiagram/templates/extensions/layouts/ForceDirectedLayout/types';
import { ForceLayoutSettings } from 'src/containers/ProjectDiagram/templates/extensions/layouts/types';

export const forceCollideSimulation = (layoutSettings: ForceLayoutSettings) =>
  forceCollide<D3LayoutNode>()
    .radius(
      ({ radius }: D3LayoutNode) => radius * layoutSettings.layoutCollideOffset
    )
    .iterations(layoutSettings.layoutCollideSimulationIterations);
